import React from 'react';
import { Button, buttonVariants } from '@/components/Button';
import { Text, textVariantsEnum, fontWeightEnum } from '@/components/Text';
import styles from './Projects.module.scss';

export const DeleteProjectModal = ({
  projectName,
  onClose,
  onConfirm,
  loading,
}) => {
  return (
    <div className={styles.deleteProjectModal}>
      <Text
        variant={textVariantsEnum.Text_md}
        fontWeight={fontWeightEnum.Semibold}
        color="gray-900"
      >
        Delete Project
      </Text>
      <Text variant={textVariantsEnum.Text_sm} color="gray-500">
        Are you sure you want to delete{' '}
        <b className="text-capitalize">{projectName || 'this project'}</b>? This
        will also remove its task list. This action cannot be undone.
      </Text>
      <div className={styles.deleteProjectModalActions}>
        <Button
          text="Cancel"
          onClick={onClose}
          variant={buttonVariants.secondary}
          disabled={loading}
        />
        <Button
          text="Delete"
          onClick={onConfirm}
          variant={buttonVariants.red}
          loading={loading}
        />
      </div>
    </div>
  );
};
